module.exports = "<gmc-panel header=\"GMC Video\" close-btn=true on-close=$ctrl.closeModal(null)><div class=\"embed-responsive embed-responsive-16by9\"><iframe class=embed-responsive-item ng-src={{$ctrl.video}} frameborder=0 allowfullscreen></iframe></div></gmc-panel>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/video-iframe-modal/video-iframe-modal.component.html
// module id = 834
// module chunks = 31